import { FIRST_PARTY_METRIC_KEYS, type FirstPartyMetricKey, type FirstPartyTrafficReport } from '@/api/firstPartyTraffic'
import { formatInteger, formatPercent } from '@/design'

import { formatRevenue, windowLabel } from './metrics'

/** A header for every metric: a record over the key list, so a metric added there does not compile without one. */
const HEADERS: Record<FirstPartyMetricKey, string> = {
  sessions: 'Sessions',
  users: 'Users',
  orders: 'Orders',
  revenueMinor: 'Revenue',
  newCustomers: 'New customers',
  conversionRate: 'Conversion rate',
  aovMinor: 'AOV',
}

export interface FirstPartyColumn {
  key: FirstPartyMetricKey
  header: string
}

/** The metrics, in the order the table and the totals show them. */
export const FIRST_PARTY_COLUMNS: readonly FirstPartyColumn[] = FIRST_PARTY_METRIC_KEYS.map((key) => ({ key, header: HEADERS[key] }))

export function formatFirstPartyMetric(key: FirstPartyMetricKey, value: number | null, currency: string): string {
  if (value === null) return '—'
  if (key === 'revenueMinor' || key === 'aovMinor') return formatRevenue(value, currency)
  if (key === 'conversionRate') return formatPercent(value)
  return formatInteger(value)
}

/** "10 Aug – 16 Aug 2026 · compared with 3 Aug – 9 Aug 2026" */
export function firstPartySubtitle(report: FirstPartyTrafficReport): string {
  const current = windowLabel(report.start, report.end)
  if (!report.compared || !report.previousStart || !report.previousEnd) return current
  return `${current} · compared with ${windowLabel(report.previousStart, report.previousEnd)}`
}
